module.exports = __webpack_public_path__ + "img/partner_img3.aecbb196.png";